export default "__VITE_ASSET__Cmgquyeu__"